import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    countries: []
}

export const countrySlide = createSlice({
    name: 'country-sidebar',
    initialState,
    reducers: {
        setCountry: (state, action:  any) => ({
            ...state,
            countries: action.payload
        })
    }
})
export const {setCountry} = countrySlide.actions;
const {reducer: countryReducer } = countrySlide;
export default countryReducer;